export function GetSingleCookieMatch(cookies) {
  let returnCookie = null;
  if (!document.cookie) {
    return returnCookie;
  }
  document.cookie.split('; ').map((data, index) => {
    if (data.indexOf(cookies) > -1) {
      returnCookie = data;
    }
  });
  return returnCookie;
}

export function SetSingleCookie(documentCookies, cookie, value) {
  documentCookies = cookie + '=' + escape(value);
}

export function GetSingleCookie(documentCookies, cookie) {
  let arr = documentCookies.match(new RegExp('(^| )' + cookie + '=([^;]*)(;|$)'));
  if (arr !== null)
    return unescape(arr[2]);
  return false
}

export function GetSingleCookie2({ key = false }) {
  if (!window) return false;
  if (!window.document) return false;
  if (!window.document.cookie) return false;
  if (!key) return false;

  let List, Reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
  if (List = document.cookie.match(Reg))
    return (List[2]);
  else
    return false
}

export function SetSingleCookie2({ key = false, value = false, time = false, domain = false, path = "/" }) {
  if (!window) return false;
  if (!window.document) return false;
  if (!window.document.cookie) return false;
  if (!key) return false;
  if (!value) return false;

  let _str_second = time || 0;
  let _exp = new Date();
  _exp.setTime(_exp.getTime() + _str_second * 1);

  let _set_cookie = key + '=' + escape(value) + ";"
  if (time) _set_cookie += "expires=" + _exp.toUTCString() + ";"
  if (domain) _set_cookie += "domain=" + domain + ";"
  _set_cookie += "path=" + path + ";"
  console.log(_set_cookie, '_set_cookie');
  window.document.cookie = _set_cookie;
}
export function SetSingleCookieV2({ key = false, value = false, time = false, domain = false, path = "/" }) {
  if (typeof window == 'undefined' || typeof window.document == 'undefined' || typeof window.document.cookie == 'undefined' || !key) return false
  let _str_millisecond = time || 0;
  let _exp = new Date();
  _exp.setTime(_exp.getTime() + _str_millisecond * 1);

  let _set_cookie = key + '=' + escape(value) + ";"
  if (key == 'keywordsHistoryV2') {
    _set_cookie = key + '=' + encodeURIComponent(value) + ";"
  }
  if (time) _set_cookie += "expires=" + _exp.toUTCString() + ";"
  if (domain) _set_cookie += "domain=" + domain + ";"
  _set_cookie += "path=" + path + ";"
  window.document.cookie = _set_cookie;
}
export function GetSingleCookieV2({ key = false }) {
  if (typeof window == 'undefined' || typeof window.document == 'undefined' || typeof window.document.cookie == 'undefined' || !key) return false
  let List, Reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
  if (List = document.cookie.match(Reg)) {
    if (key == 'keywordsHistoryV2') {
      return decodeURIComponent(List[2]);
    }
    return unescape(List[2]);
  }
  return false
}

export function DelSingleCookie2({ key = false }) { // 此方法有误
  if (!window) return false;
  if (!window.document) return false;
  if (!window.document.cookie) return false;
  if (!key) return false;

  let _exp = new Date();
  _exp.setTime(_exp.getTime() - 1);

  let _cval = GetSingleCookie2({ key })
  if (_cval) window.document.cookie = key + '=' + _cval + ";expirse=" + _exp.toUTCString();
}

export function DelSingleCookie3({ key = false, domain = false, path = "/" }) {
  if (!window) return false;
  if (!window.document) return false;
  if (!window.document.cookie) return false;
  if (!key) return false;

  let _exp = new Date();
  _exp.setTime(_exp.getTime() - 1);
  let _set_cookie = key + '=; expires=' + _exp.toUTCString() + ";"
  if (domain) _set_cookie += " domain=" + domain + ";"
  _set_cookie += " path=" + path + ";"
  window.document.cookie = _set_cookie;
}

export function delToken( ) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/";
}



// WEBPACK FOOTER //
// ./common/Utils/cookieUtil.js